import useMutation from "src/hooks/useMutation";

function useBatchCount() {
  return useMutation({
    path: "/api/v1/batches/valid-file",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/batches`,
      shouldRevalidate: true,
    },
  });
}

export default useBatchCount;
